// import { useEffect } from "react";

import Introduction from "./Introduction";
import Roadmap from "./Roadmap";
import FAQ from "./FAQ";
import Team from "./Team";
// import Join from "./Join";
import Navigation from "./Navigation";
import styled from 'styled-components'



export default function Body() {
    const Div = styled.div`
        background-color: #7A2D2D;
        margin: 0;
        .show {
            color: white;
            opacity: 1;
            transition: all 3s;
        }
        .hidden {
            opacity: 0;
        }
    `


    return (
        <Div >
            <Navigation />
            <Introduction/>
            <Roadmap />
            <FAQ />
            <Team/>
            {/* <Join /> */}
            {/* <Footer /> */}
        </Div>
    )
}